/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import '~nouislider/dist/nouislider.css';
@import "../../scss/vars";

:host {
  display: block;
  padding-left: 10px;
  padding-right: 10px;

  & > div {
    position: relative;
  }

  #slider {
    height: 10px;
    margin-top: 40px;
    margin-bottom: 40px;

    .noUi-handle:hover {
      cursor: grab;
    }

    .noUi-handle.noUi-active {
      cursor: grabbing !important;
    }

    .noUi-pips.noUi-pips-horizontal {
      .noUi-value {
        padding-top: 5px;

        &:nth-child(2) {
          transform: translate(0, 50%);
          margin-left: -10px;
        }

        &:last-child {
          transform: translate(-100%, 50%);
          margin-left: 10px;
        }
      }
    }

    &.discovery-date {
      margin: 60px 40px 70px;
    }

    .noUi-tooltip {
      background: var(--warp-view-tooltip-bg-color, $w10-white);
      color: var(--warp-view-tooltip-label-color, rgb(102, 102, 102));
      border-radius: 4px;
      font: 14px / 21px sans-serif;
      padding-left: 10px;
      padding-right: 10px;
      border: 1px solid var(--warp-view-tooltip-border-color, $w10-lightgrey);
      margin-bottom: 3px;

      &:after, &:before {
        top: 100%;
        left: 50%;
        border: solid transparent;
        content: "";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }

      &:after {
        border-color: rgba(213, 0, 156, 0);
        border-top-color: var(--warp-view-tooltip-bg-color, $w10-white);
        border-width: 5px;
        margin-left: -5px;
      }

      &:before {
        border-color: rgba(217, 217, 217, 0);
        border-top-color: var(--warp-view-tooltip-border-color, $w10-lightgrey);
        border-width: 6px;
        margin-left: -6px;
      }
    }

    &.noUi-target {
      border-radius: 4px;
      background: var(--warp-view-input-bg-color, $w10-white);
      border: 1px solid var(--warp-view-input-border-color, $w10-lightgrey);
    }

    .noUi-base {
      border-radius: 3px;
      border-width: 0;
      background: var(--warp-view-input-bg-color, $w10-white);
    }

    .noUi-connect {
      border-radius: 3px;
      background: var(--warp-view-active-input-bg-color, $w10-blue);
    }

    .noUi-value {
      font: 14px / 21px sans-serif;
      color: var(--warp-view-chart-label-color, $w10-charcoal);
    }

    .noUi-marker, .noUi-marker-sub, .noUi-marker-large {
      background: var(--warp-view-chart-grid-color, $w10-charcoal);
    }

    .noUi-handle {
      height: 18px;
      width: 18px;
      top: -5px;
      right: -9px; /* half the width */
      border: 1px solid var(--warp-view-input-border-color, $w10-lightgrey);
      border-radius: 9px;
      background-color: var(--warp-view-handle-bg-color, $w10-white);
    }

    .noUi-handle:before, .noUi-handle:after {
      display: none;
    }

    &[disabled] {
      .noUi-connect {
        background: var(--warp-view-input-disabled-bg-color, $w10-lightgrey);
      }

      .noUi-handle {
        background-color: var(--warp-view-handle-disabled-bg-color, $w10-lightgrey);
      }
    }
  }
}
